import React from "react";
import { connect } from "react-redux";

import {getCurrentGroups} from "../../look/lookNavigation/lookMain/lookWizard/lookWizardFunctions";
import MaterialsWizardMain from "./materialsWizardMain";
import MaterialsWizardHistoryListener from "./materialsWizardHistoryListener";


const MaterialsWizardBody = (props) => {

  const {wizardSelectedValues, wizardActiveStep, wizardActiveItem} = props;
  // const wizardTimeoutId = useRef();

  // const [additionalFeaturesLoading, setAdditionalFeaturesLoading] = useState(false);

  // const updateLocationLogic = () => {
  //   clearTimeout(wizardTimeoutId.current);
  //   wizardTimeoutId.current = setTimeout(lookHistoryListener, 0);
  // };

  const currentGroups = getCurrentGroups(wizardActiveItem, wizardActiveStep, wizardSelectedValues);

  return (
    <MaterialsWizardHistoryListener>
      <MaterialsWizardMain currentGroups={currentGroups}/>
    </MaterialsWizardHistoryListener>
  )

};

const mapStateToProps = (store) => {
  const {wizardList, wizardActiveItem, wizardSelectedValues, wizardActiveStep} = store.wizardState;
  const {selectionFeatureInfo} = store.selectionState;
  const {filterGroups} = store.filterState;

  return {
    wizardList,
    wizardActiveItem,
    wizardSelectedValues,
    wizardActiveStep,
    selectionFeatureInfo,
    filterGroups,
  };
};

export default connect(mapStateToProps)(MaterialsWizardBody)
